// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"b7167c93114509dbcea1","291":"4254e63a6abe2087851c","383":"ebfa21aba4c6f98b11bb","672":"181e6bf6446312d04668"}[chunkId] + ".js";
};